import { render, staticRenderFns } from "./RiskLogSearchForm.vue?vue&type=template&id=1bc40c73&scoped=true"
import script from "./RiskLogSearchForm.vue?vue&type=script&lang=ts"
export * from "./RiskLogSearchForm.vue?vue&type=script&lang=ts"
import style0 from "./RiskLogSearchForm.vue?vue&type=style&index=0&id=1bc40c73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc40c73",
  null
  
)

export default component.exports